const API_BASE = "";

export type CheckoutStatus = {
  email_hint: string;
  membership_status: string;
  plan_interval: string;
  setup_required: boolean;
};

async function readError(response: Response, fallback: string): Promise<Error> {
  try {
    const data = await response.json();
    if (typeof data?.detail === "string") {
      return new Error(data.detail);
    }
  } catch {
    // Use the calm, user-facing fallback below.
  }

  return new Error(fallback);
}

export async function getCheckoutStatus(sessionId: string): Promise<CheckoutStatus> {
  const response = await fetch(`${API_BASE}/memberships/checkout/status`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ session_id: sessionId }),
  });

  if (!response.ok) {
    throw await readError(
      response,
      "We could not confirm this membership payment. Please try again."
    );
  }

  return response.json();
}

export async function completeMembershipSetup(
  sessionId: string,
  password: string,
  displayName: string | undefined,
  marketingEmailsOptedOut: boolean
): Promise<{ detail: string }> {
  const response = await fetch(`${API_BASE}/memberships/checkout/complete`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      session_id: sessionId,
      password,
      display_name: displayName?.trim() || null,
      marketing_emails_opted_out: marketingEmailsOptedOut,
    }),
  });

  if (!response.ok) {
    throw await readError(
      response,
      "We could not finish setting up your account. Please try again."
    );
  }

  return response.json();
}
